import { useEffect, useState } from 'react';

const useMutationObserver = selector => {
  const [element, setElement] = useState(null);

  useEffect(() => {
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const foundElement = document.querySelector(selector);
          setElement(foundElement);
          break;
        }
      }
    });

    observer.observe(document.body, { attributes: false, childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, [selector]);

  return element;
};

export default useMutationObserver;
